//import { fromJS } from 'immutable';
import assign       from 'object-assign';

import { 
  //INITIAL_DATA,
  PRESENTATION_INIT_DATA, 
  SLIDE_DATA, 
  SLIDE_PREVIEW, 
  PPTS_OPEN,
  SELECTED_PPT, 
  PPTS_CLOUD, 
  SESSION_CODE, 
  USER_COUNT, 
  SLIDE_STATIC_DATA,
  TITLE_BAR, 
  SLIDE_INDEX, 
  FULLSCREEN, 
  STATE_LOADING_PRESENTATION, 
  LANGUAGE,
  ORIENTATION, 
  KEYBOARD, 
  CONFIG_SHARE,
  OPEN_MODAL, 
  CLOSE_MODAL,
  CLOSE_CONFIG,
  OPEN_CONFIG,
  PRESENTATION_MODE_CONFIG,
  SUBMENU_CONFIG,
  HOTPLUGIN_INFO,
  SET_AUDITORIUM_MODE,
} 
from './constants';

window.temp = (btnName) => {
  console.log('Llama con ' + btnName)
}

export const initialState = {
  currentData: {
    slideName: "",
    //previewUrl: "https://www.google.com.co/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png",
    previewUrl: process.env.REACT_APP_URL_SERVICES + "images/nopreview.png",
    indexSlide: "-1",
    totalSlides: "0",
    idToglea: "",
    urlActivity: "",
    idUserPresentation: "",
    titleActivity: "",
    infoActivity: "",

    //data que se usa cuando es presentador
    usersCount: 0,
    noteSlide: "",
    localPPTs:null,
    cloudPPTs:null,
    isCloud: false,
    sessionCode: "",   

  },

  configPPT: {
    shareFinish: false,
  },

  orientation: "none",
  keyboard: false,

  titleAppBar: "Flipwit",
  showMenu: true,
  backEnabled: false,
  isFullScreen: false,
  stateLoadingPresentation: "",
  language: "en",

  modalWindow: {
    opened: false,
    title: '',
    message: '',
    buttons: undefined
    //Los botones siguen la siguiente estructura, si el boton tiene callback entonces se llama el mismo
    //pasandole como parametro el label, si no se le pasa callback simplemente cierra el modal
    //buttons: [{label:'OK',callback:window.temp},{label:'Cancel'}]
  },

  configWindow: {
    opened: false,
  },

  /*
    showMenuTools: si se muestran en el menú las opciones de dibujar y laser
    showPreview: si se muestra o no el menú
    showDrawTools: si se esta mostrando en el momento el panel de dibujo
    showLaserPointer: si se esta mostrando en el momento el panel de laser
    showHotPlugin: si va a mostrar una ventana de HotPlugin (los plugins que se activan sin diapositiva), null no, y cuando
                    hay tiene un objeto con el nombre del plugin y la vista que muestra en donde se activa, por ejemplo
                    {pluginName: 'connection',pluginView: 'viewer'}

   */
  configPresentationMode: {
    showMenuTools: false,
    showPreview: true,
    showUrlBar: true,
    showHotPlugin: null,    
    showDrawTools: false,
    showLaserPointer: false,
    questionsAmountForPresentation: 0,
  }, 

  configSubMenu: {
    opened: false,
    subMenus: []
  },

  hotPluginInfo: {},

  auditorium:{
    isAuditoriumMode : false,
  },

};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRESENTATION_INIT_DATA:
      return assign({}, state, {
        currentData: assign({}, state.currentData, {
          slideName: action.name,
          idUserPresentation: action.user,
        }),
      });

    case SLIDE_DATA:
      return assign({}, state, {
        currentData: assign({}, state.currentData, {
          urlActivity: action.data.communData.url,
          indexSlide: action.data.communData.slideIndex,
          idToglea: action.data.communData.idToglea,
          titleActivity: action.data.communData.titleToglea,
          infoActivity: action.data.communData.infoToglea,
          noteSlide: action.data.comment,
          previewUrl: action.data.communData.previewUrl,        
        }),
      });

      case SLIDE_STATIC_DATA:
      return assign({}, state, {
        currentData: assign({}, state.currentData, {
          totalSlides: action.data.totalSlides,
        }),
      });

     case SLIDE_PREVIEW:
     return assign({}, state, {
        currentData: assign({}, state.currentData, {
          previewUrl: action.data.previewUrl,       
        }),
      });

      case PPTS_OPEN:
        return assign({}, state, {
          currentData: assign({}, state.currentData, {
            localPPTs: action.data,       
        }),
      });

      case PPTS_CLOUD:
        return assign({}, state, {
          currentData: assign({}, state.currentData, {
            cloudPPTs: action.data,       
        }),
      });

      case SELECTED_PPT:
        return assign({}, state, {
          currentData: assign({}, state.currentData, {
            slideName: action.name,
            isCloud: action.isCloud,
        }),
      });

      case SESSION_CODE:
        return assign({}, state, {
          currentData: assign({}, state.currentData, {
            sessionCode: action.data,
        }),
      });
      
      case USER_COUNT:
        return assign({}, state, {
          currentData: assign({}, state.currentData, {
            usersCount: action.data,
        }),
      });

      case TITLE_BAR:
        return assign({}, state, {
          titleAppBar: action.title,
          showMenu: action.showMenu===undefined?state.showMenu:action.showMenu
        });          
        

      case SLIDE_INDEX:
        return assign({}, state, {
          currentData: assign({}, state.currentData, {
            indexSlide: action.data,
        }),
      });

      case FULLSCREEN:
        return assign({}, state, {
          isFullScreen: action.data,
        });

      case STATE_LOADING_PRESENTATION:
        return assign({}, state, {
          stateLoadingPresentation: action.data,
        });

      case LANGUAGE:
        return assign({}, state, {
          language: action.data.lang,
          //TEXTS: action.data.TEXTS,
          //TITLES: action.data.TITLES,
        });

      case ORIENTATION:
        return assign({}, state, {
          orientation: action.data,
          //TEXTS: action.data.TEXTS,
          //TITLES: action.data.TITLES,
        });

      case KEYBOARD:
        return assign({}, state, {
          keyboard: action.data,
          //TEXTS: action.data.TEXTS,
          //TITLES: action.data.TITLES,
        });

      case CONFIG_SHARE:
        return assign({}, state, {
          configPPT: assign({}, state.configPPT, action.config),
        });

      case OPEN_MODAL:   
        return assign({}, state, {
          modalWindow: assign({}, state.modalWindow, action.modalWindow),
        });

      case CLOSE_MODAL: 
        return assign({}, state, {
          modalWindow: {
            opened: false,
            title: '',
            message: '',
            buttons: undefined            
          },
        });

      case CLOSE_CONFIG: 
        return assign({}, state, {
          configWindow: {
            opened: false,
          },
        });

      case OPEN_CONFIG: 
        return assign({}, state, {
          configWindow: {
            opened: true,
          },
        });

      case PRESENTATION_MODE_CONFIG:
        return assign({}, state, {
          configPresentationMode: assign({}, state.configPresentationMode, {
            [action.config]: action.data,
          })
        });

      case SUBMENU_CONFIG:
        let isOpened = action.subMenus.length>0;
        console.log('REDUCER Coloca opened en ',isOpened,"por",action.subMenus, 'quedando',assign({}, state, {
          configSubMenu: {
            opened: isOpened,
            subMenus: action.subMenus
          }          
        }))

        return assign({}, state, {
          configSubMenu: {
            opened: isOpened,
            subMenus: action.subMenus
          }          
        }); 

      case SET_AUDITORIUM_MODE:
        return assign({}, state, {
          auditorium: assign({}, state.auditorium, {isAuditoriumMode:action.isAuditoriumMode}),
        });     

      
      case HOTPLUGIN_INFO:
        return assign({}, state, {
          hotPluginInfo: action.data          
        }); 
      

      default:
        return state;
  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/containers/App/reducer.js